import { Dropdown } from "@nova/component-dropdown"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { ReactNode } from "react"
import { ColorPicker } from "./ColorPicker"

const Swatch = ({
    selected,
    color,
    image,
    onClick,
    children,
}: {
    selected: boolean
    color?: string | null
    image?: string
    onClick?: () => void
    children?: ReactNode
}) => (
    <button
        type="button"
        onClick={onClick}
        style={{
            backgroundColor: color ?? undefined,
            backgroundImage: image && `url(${image})`,
        }}
        className="relative w-8 h-8 shrink-0 rounded-lg overflow-hidden bg-cover flex items-center justify-center hover:brightness-125"
    >
        <span
            className={classNames(
                "absolute inset-0 rounded-lg border",
                selected ? "border-gray-0" : "border-transparent"
            )}
        />
        {selected ? (
            <Icons.SmallIcon
                Icon={Icons.CheckmarkShadow}
                className={color === "#FFFFFF" ? "text-gray-900" : "text-gray-0"}
            />
        ) : (
            children
        )}
    </button>
)

export const ColorSwatchSelector = ({
    colors,
    color,
    onChange,
}: {
    colors: readonly string[]
    color: string | null
    onChange: (color: string | null) => void
}) => {
    const customColor = color && !colors.includes(color) ? color : null

    return (
        <div className="flex flex-col gap-2">
            <label className="text-gray-100">Color</label>
            <div className="flex flex-1 items-center justify-between">
                <Swatch selected={!color} onClick={() => onChange(null)}>
                    <Icons.LargeIcon
                        Icon={Icons.TransparentSwatch}
                        className="absolute inset-0 text-gray-700"
                    />
                </Swatch>
                {colors.map((c) => (
                    <Swatch key={c} selected={color === c} color={c} onClick={() => onChange(c)} />
                ))}
                <Dropdown>
                    <Dropdown.Trigger as="div">
                        <Swatch
                            selected={!!customColor}
                            color={customColor}
                            image={customColor ? undefined : "/images/rainbow-color.webp"}
                        />
                    </Dropdown.Trigger>
                    <Dropdown.Menu unstyled position="bottom-right">
                        <ColorPicker
                            selectedColor={color ?? colors[0]}
                            setSelectedColor={onChange}
                            allowAlpha={false}
                        />
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
    )
}
